import * as React from "react";
import { Modal } from "antd";
import "./certificates.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { useState } from "react";
import { CertificatesModal } from "./CertificatesModal";

interface IViewCertificatesButton {
    trade: ITrade;
}

export const ViewCertificatesButton: React.FC<IViewCertificatesButton> = ({ trade }) => {

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <button className="view-bcheck btn" onClick={() => setShowModal(true)} >
                <FontAwesomeIcon icon={faUpload} />
                Certificados
            </button>
            <Modal className="modal-view-trade-bcheck" title="Certificates" visible={showModal} footer={[]} onCancel={() => setShowModal(false)}>
                <CertificatesModal
                    trade={trade}
                />
            </Modal>
        </>
    );
}


// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/certificates/ViewCertificatesButton.tsx